export const DELETE_PRE_USER = "DELETE_PRE_USER";
export const SET_PRE_USER = "SET_PRE_USER";
export const SET_CONTRIBUTOR = "SET_CONTRIBUTOR";
export const CHANGE_PRE_STATUS = "CHANGE_PRE_STATUS";
export const CHANGE_PRE_MEMBERSHIP = "CHANGE_PRE_MEMBERSHIP";
export const ADD_PRE_USER = "ADD_PRE_USER";
export const PRE_COURSE_UNENROLL = "PRE_COURSE_UNENROLL";
export const EDIT_PRE_USER = "EDIT_PRE_USER";
export const DELETE_CONTRIBUTOR = "DELETE_CONTRIBUTOR";
